import { type FunctionComponent, type HTMLAttributes } from 'react';
import { type ImageFieldsFragment, type ProductResourceFieldsFragment } from '../../../../__generated__/graphql-client-types';
import { ProductImage, ProductPrice } from '../../../product-components/product-information/product-information.component';
import CheckIcon from '../../../svgs/check.svg';
import { optionPill, productOption } from '../product-option.css';

export type OptionPillProps = {
	testId?: string;
	showCheckmark?: boolean;
	startingPrice?: number | null;
	name: string;
	selected?: boolean;
	image: ImageFieldsFragment | null;
	resource?: ProductResourceFieldsFragment | null;
	params?: Record<string, any>;
} & Pick<HTMLAttributes<HTMLElement>, 'className'>;

/**
 * Option Pill Component
 */
export const OptionPill: FunctionComponent<OptionPillProps> = ({
	className = 'w5 ba b--theme-grey-light b--solid br2',
	testId = '',
	name,
	image,
	resource,
	selected,
	startingPrice = null,
	showCheckmark = false
}) => {
	return (
		<div className={`${productOption} ${className ?? ''}`.trim()} data-testid={testId}>
			<div className={`flex flex-row justify-start items-center w-100 w-auto-ns ph2 ${optionPill}`}>
				<ProductImage className="pr2" image={image} options={{ width: 55, height: 55 }} />
				<div className={`flex flex-column items-start justify-between h-100 w-80 ${showCheckmark ? '' : 'mr2'}`.trim()}>
					<div className="tc2-title tl f6">{name}</div>
					{resource?.price && <ProductPrice price={resource.price} />}
					{startingPrice && <div className="theme-grey f6">Starting at ${startingPrice}</div>}
				</div>
				{showCheckmark && selected && <CheckIcon className="f4 theme-primary pl0 pt2 pb2 pr2" data-testid="CheckIcon" />}
			</div>
		</div>
	);
};
